export default class IntegrationClaudeAPIService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  // Config
  getConfig()                         { return this.httpClient.get(`/integrations/claude/config`) }
  updateConfig(data)                  { return this.httpClient.put(`/integrations/claude/config`, data) }
  
}
